import React, { useEffect, useState } from 'react';
import { Dropdown, Typography, Table, Menu, TablePaginationConfig } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { ITableFilterRequestParameters, IMenuPageProps } from 'types';
import { api } from 'services/api';
import {SearchInput} from 'components';
import "./style.scss";

// Use isso para disparar o refresh da tabela quando necessário:
// const [refreshTable, setRefreshTable] = useState<boolean>(false);
// const handleRefreshTable = () => {
//	 	setRefreshTable(true);
// 		setTimeout(() => {
// 		  setRefreshTable(false);
// 		}, 1000);
//   };
// tem que passar a constante refreshTable via props: <MenuPage ...outras_props refreshData={refreshTable}>
// ao chamar o metodo handleRefreshTable() a tabela irá recarregar os dados

export const MenuPage: React.FC<IMenuPageProps> = (props) => {
	const {
		sourceDataUrl, 
		tableColumns, 
		noPadding,
		title="Menu Page", 
		subtitle,
		addButtonText = 'Adicionar', 
		onClickAdd = ()=>{alert('add action using the onClickAdd props')}, 
		showAddButton = true, 
		isLoading = false, 
		itemsPerPage=10, 
		refreshData = false, 
		getDataFromResponse,
		searchPlaceholder="Buscar"
	} = props 
	const [tableData, setTableData] = useState<any[]>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [seachTerm, setSeachTerm] = useState<string|undefined>(undefined);
	const [perPage, setPerPage] = useState<number>(itemsPerPage || 10);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [tableFilterRequestParams, setTableFilterRequestParams] = useState<ITableFilterRequestParameters>();

	useEffect(() => {
		const tfrp = tableFilterRequestParams;
		const params = {page: paginationInfo?.current || 1, per_page: Number(perPage), paginate: true, search: seachTerm === ''? undefined : seachTerm}
		
		if(JSON.stringify(tfrp) === JSON.stringify(params)) {
			return;
		}

		if(tfrp && tfrp.search !== params.search){
			params.page = 1
		}

		setTableFilterRequestParams(params)

		api
			.get(
				sourceDataUrl, 
				{
					params: params,
				}
			)
			.then((res) => {
				if(getDataFromResponse) {
					setTableData(getDataFromResponse(res?.data))
				} else {
					setTableData(res?.data?.data);
				}
				setTotalItensValue(Number(res?.data?.pagination?.total));
			});

	}, [perPage, paginationInfo, seachTerm, tableFilterRequestParams, sourceDataUrl, getDataFromResponse]);


	useEffect(() => {
		if(refreshData !== true) {
			return;
		}
		
		const params = {page: 1, per_page: 10, paginate: true}

		api
			.get(
				sourceDataUrl, 
				{
					params: params,
				}
			)
			.then((res) => {
				if(getDataFromResponse) {
					setTableData(getDataFromResponse(res?.data))
				} else {
					setTableData(res?.data?.data);
				}
				setTotalItensValue(Number(res?.data?.pagination?.total));
			});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refreshData]);


	const menu = (
		<Menu
			selectable
			onClick={(e) => setPerPage(Number(e.key))}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: 10,
					label: "10",
				},
				{
					key: 20,
					label: "20",
				},
				{
					key: 30,
					label: "30",
				},
				{
					key: 40,
					label: "40",
				},
			]}
		/>
	);

  const renderAddButton = () => {
    if (showAddButton === true) {
      return <button
              className="menu-page__container__top__btn"
              onClick={() => onClickAdd()}
            >
              {addButtonText}
            </button>;
    }

    return;
  }

  const renderTitle = () => {
    if (title) {
      return  <h1 className="menu-page__container__title">{title}</h1>;
    }

    return;
  }

  const renderSubtitle = () => {
    if (subtitle) {
      return  <p className="menu-page__container__subtitle">{subtitle}</p>;
    }

    return;
  }

  return (
    <div className="menu-page">
      <div className="menu-page__container" style={{padding: noPadding? 0 : '20px'}}>
		{renderTitle()}
		{renderSubtitle()}
        <div className="menu-page__container__top p-1 d-flex flex-lg-row flex-column mt-3 mb-2">
			<div className='d-flex flex-grow-1 justify-content-between align-items-center' style={{width: '100%'}}>
				<div className="menu-page__container__top__per-page-number">
					<span style={{marginRight: 5}}>Exibir</span> 
					{
					<Dropdown overlay={menu}>
						<Typography.Text>
						{perPage}
						<DownOutlined style={{ marginLeft: "5px" }} />
						</Typography.Text>
					</Dropdown>
					}{" "}
				</div>
				<div style={{width: '40%'}} className='d-none d-lg-block'>
					<SearchInput placeholder={searchPlaceholder} onSearch={setSeachTerm}/>
				</div>
				<div className="justify-self-end">
					{renderAddButton()}
				</div>
			</div>
			<div style={{width: '100%'}} className='d-xs-block d-lg-none mt-3'>
				<SearchInput placeholder={searchPlaceholder} onSearch={setSeachTerm}/>
			</div>
        </div>
		<div className="row">
			<div className="col-12">
				<Table
					className='table table-responsive'
					rowKey="id"
					loading={tableData === undefined || isLoading}
					columns={tableColumns}
					dataSource={tableData}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: perPage,
					}}
				/>
			</div>
		</div>
      </div>
    </div>
  );
};
